export const environment = {
    production: false,
    version: '1.1.1',
    clientId: 'aV8nHGIWFutBBb',
    provider: 'https://fedauth.qa.alaskasworld.com',
    airtalkUrl: 'https://apis.qa.alaskaair.com/1/airlines/operations/airtalk',
    airtalkSubscriptionKey: '3bc0917f80a14ee28e3c0a666430da20',
    apiBaseUrl: 'https://apis.alaskaair.com',
    flightInfoSubscriptionKey: '5e5686c737f548a685b87ffd6cfff11b'
};
  